export default __webpack_public_path__ + "static/media/music.a03b6d65.bmp";